@if (rows().length) {
  <div class="list">
    @for (row of rows(); track row.id) {
      <div class="row" (click)="onRowClick(row)">
        <div class="pin-num">{{ row.number }}</div>
        <div class="body">
          <div class="title">
            <span class="t-text">{{ row.title }}</span>
            @if (row.unread) {
              <span
                class="unread-badge"
                [title]="row.unread === 1 ? '1 unread comment' : row.unread + ' unread comments'"
                >{{ row.unread }}</span
              >
            }
            <!-- Stop the click so changing status doesn't also open the detail. -->
            <fb-status-chip
              [statuses]="statuses"
              [current]="row.status"
              (statusChange)="onStatusChange(row, $event)"
              (click)="$event.stopPropagation()"
            />
          </div>
          <div class="meta">
            <span class="device">
              @switch (row.device) {
                @case ('mobile') {
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="7" y="2" width="10" height="20" rx="2" /><path d="M11 18h2" /></svg>
                }
                @case ('tablet') {
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="2" width="14" height="20" rx="2" /><path d="M11 18h2" /></svg>
                }
                @default {
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="4" width="20" height="13" rx="2" /><path d="M8 21h8M12 17v4" /></svg>
                }
              }
              {{ row.deviceLabel }}
            </span>
            <span class="dot">·</span>
            <span>{{ row.timeAgo }}</span>
            @if (row.type) {
              <span class="dot">·</span>
              <span class="type-dot t-{{ row.type }}" [title]="row.type + ' feedback'">
                @if (row.type === 'AI') {
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2v4" /><rect x="4" y="6" width="16" height="13" rx="2.5" /><circle cx="9" cy="12.5" r="1.2" fill="currentColor" stroke="none" /><circle cx="15" cy="12.5" r="1.2" fill="currentColor" stroke="none" /><path d="M9.5 16h5" /><path d="M2 13v3" /><path d="M22 13v3" /></svg>
                } @else {
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>
                }
              </span>
            }
          </div>
        </div>
      </div>
    }
  </div>

  @if (showPager()) {
    <div class="pager">
      <div class="pg-info">{{ rangeStart() }}–{{ rangeEnd() }} of {{ total() }}</div>
      <button type="button" aria-label="Previous" [disabled]="page() === 1" (click)="goTo(page() - 1)">‹</button>
      @for (number of pageNumbers(); track number) {
        <button type="button" [class.is-active]="number === page()" (click)="goTo(number)">{{ number }}</button>
      }
      <button type="button" aria-label="Next" [disabled]="page() === lastPage()" (click)="goTo(page() + 1)">›</button>
    </div>
  }
} @else {
  <div class="empty">
    <div class="ill">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" /><circle cx="12" cy="10" r="3" /></svg>
    </div>
    <h3>No feedback yet</h3>
    <p>Click <b>Add feedback</b> and drop a pin anywhere on the page.</p>
  </div>
}
